import React from 'react'
import LendAndBorrow from '../../components/LendAndBorrow/LendAndBorrow'

const LendAndBorrowSection = () => {
    return (
        <>
            <LendAndBorrow/>
        </>
    )
}

export default LendAndBorrowSection
